import {eTipoPermissao} from "@/enums/ePermissoes";

export default [
 {
  description: "Conta Corrente",
  path: "/prestacaocontas/pcocontacorrente",
  name: "pcocontacorrente",
  component: () => import("@/views/prestacaocontas/pcocontacorrente/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.CONTACORRENTENOVO_MENU_1500300399],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Conta Corrente",
  path: "/prestacaocontas/pcocontacorrente/cadastro/:id?",
  parent: "pcocontacorrente",
  name: "pcocontacorrente_create",
  component: () => import("@/views/prestacaocontas/pcocontacorrente/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.CONTACORRENTENOVO_MENU_1500300399],
  },
  goesToMenu: true,
 },
]
